// extracted by mini-css-extract-plugin
export default {"modalBody":"AvatarModal_modalBody__obO7s"};